<template>
  <!-- Failed Login Notifications -->
  <fieldset class="border-2 border-primary rounded p-4 flex flex-col gap-y-1">
    <legend class="px-4 text-lg md:text-xl capitalize">
      {{ $t('failedLoginNotifications') }}
    </legend>
    <div class="ltr:font-sans text-xs flex flex-col text-brand-black-secondary">
      <p>
        {{ $t('failedLoginNotificationsInformativeMSG') }}
      </p>
      <p>
        {{ $t('failedLoginNotificationsInformativeNoteMSG') }}
      </p>
    </div>
    <div class="flex items-center gap-x-20">
      <div class="flex gap-x-3">
        <span class="text-brand-black-title">{{ $t('status') }}</span>
        <span v-if="userProfile?.enableSendFailedLoginNotification" class="text-brand-green">
          {{ $t('active') }}
        </span>
        <span v-else class="text-brand-red">
          {{ $t('inActive') }}
        </span>
      </div>
      <button
        v-if="userProfile?.enableSendFailedLoginNotification"
        class="px-3 py-0.5 text-center rounded-md bg-primary/80 hover:bg-primary flex items-center gap-x-2 hover:scale-[1.02] active:scale-100 disabled:bg-gray-300 disabled:hover:scale-95 disabled:cursor-not-allowed text-white"
        @click.stop.prevent="modal = true"
      >
        {{ $t('disableBtn') }}
      </button>
      <button
        v-else
        class="px-3 py-0.5 text-center rounded-md bg-primary/80 hover:bg-primary flex items-center gap-x-2 hover:scale-[1.02] active:scale-100 disabled:bg-gray-300 disabled:hover:scale-95 disabled:cursor-not-allowed text-white"
        @click.stop.prevent="changeFailedLoginNotification"
      >
        {{ $t('enableBtn') }}
      </button>
    </div>
    <Modal :title="$t('verifyPassword')" v-model="modal">
      <template #bodyContent>
        <Form key="passwordVerificationForm" v-slot="{ values, resetForm }">
          <Field
            :rules="requiredRule"
            validate-on-input
            validate-on-change
            validate-on-blur
            name="password"
            v-slot="{ field, errors: errs }"
          >
            <TextInput
              :field="field"
              :errors="errs"
              :label="$t('pleaseEnterYourPassword')"
              input-type="password"
              label-class="w-full"
              class="w-full"
              direction="flex-col"
            />
          </Field>
          <div class="pb-2 w-full flex justify-end">
            <button
              class="text-center rounded-md bg-primary/80 hover:bg-primary flex items-center gap-x-2 hover:scale-[1.02] active:scale-100 disabled:bg-gray-300 disabled:hover:scale-95 disabled:cursor-not-allowed text-white"
              @click.prevent="changeFailedLoginNotification(values), resetForm()"
            >
              <div class="p-2 bg-primary rounded-s-md">
                <faCheck class="w-4 fill-white"></faCheck>
              </div>
              <span class="w-full text-center">
                {{ $t('Verfiy') }}
              </span>
              <div class="p-0.5"></div>
            </button>
          </div>
        </Form>
      </template>
      <template #footerContent>&nbsp;</template>
    </Modal>
  </fieldset>
</template>

<script setup>
import faCheck from '@/assets/icons/faCheck.svg?component'
import TextInput from '@/components/SimpleForm/TextInput.vue'
import Modal from '@/components/Ui/Modal/index.vue'
import axiosInstance from '@/services'
import { notify } from 'notiwind'
import { Field, Form } from 'vee-validate'
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'

const i18n = useI18n()
const emit = defineEmits(['onChange'])
const modal = ref()

function requiredRule(value) {
  if (!value || !`${value}`.trim()) {
    return i18n.t('INVALID_REQUIRED')
  }

  return true
}

const props = defineProps({
  userProfile: Object
})

const changeFailedLoginNotification = async (verifyPasswordForm = {}) => {
  const { enableSendFailedLoginNotification } = props.userProfile

  const body = {
    enableFailedLoginNotification: !enableSendFailedLoginNotification
  }

  if (Object.values(verifyPasswordForm).length > 0) {
    Object.assign(body, verifyPasswordForm)
  }

  try {
    const response = await axiosInstance.post(
      '/api/userProfile/update/failedLoginNotification/',
      body
    )

    if (response) {
      modal.value = false
      emit('onChange', body.enableFailedLoginNotification)

      notify(
        {
          group: 'success',
          title: i18n.t(
            props.userProfile.enableSendFailedLoginNotification
              ? 'theFailedLoginNotificationDisabled'
              : 'theFailedLoginNotificationEnabled'
          )
        },
        6000
      )

      return
    }

    throw new Error()
  } catch (error) {}
}
</script>

<style lang="scss" scoped></style>
